import { NOTIFY_SMTP_START, NOTIFY_SMTP_DATA, NOTIFY_SMTP_UPSERT, NOTIFY_SMTP_DELETE, NOTIFY_SMTP_END } from '../../slices/type';

interface InitState { data: any; loading: boolean; error: any; }
const initState: InitState = { data: null, loading: false, error: null };
interface Action { type: string; payload?: any; loading?: boolean; }

const NotifySmtpConfig_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case NOTIFY_SMTP_START:  return { ...state, loading: true };
    case NOTIFY_SMTP_DATA:   return { ...state, data: action.payload, loading: false };
    case NOTIFY_SMTP_UPSERT: return { ...state, data: action.payload, loading: false };
    case NOTIFY_SMTP_DELETE: return { ...state, data: null, loading: false };
    case NOTIFY_SMTP_END:    return { ...state, error: action.payload, loading: false };
    default: return state;
  }
};

export default NotifySmtpConfig_Red;
